import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Form from "./Form";
import Spacer from "./Spacer";
import AuthLayout from "./AuthLayout";

export default function Logout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <AuthLayout
      heading="Sign out of your account"
      message="Click the button below to log out."
    >
      <Spacer size="large" />
      <Form
        path="logout"
        fields={[]}
        submitText="Logout"
        updateCache={false}
        submitCallback={() => {
          queryClient.setQueryData(["user"], null);
          navigate("/login");
        }}
      />
    </AuthLayout>
  );
}
